<div class="chat-switcher">

  <!-- Search field (MatDialog focuses it on open) -->
  <div class="chat-switcher__field d-flex align-items-center gap-2 px-3 py-2 border-bottom">
    <i class="ri-search-2-line text-muted flex-shrink-0"></i>
    <input
      type="text"
      class="form-control border-0 shadow-none px-0"
      name="chatSwitcherTerm"
      autocomplete="off"
      [placeholder]="'chat.switcher.placeholder' | translate"
      [attr.aria-label]="'chat.switcher.placeholder' | translate"
      [(ngModel)]="term"
      (input)="onTermChange()"
    >
    <button
      type="button"
      class="btn btn-sm btn-light flex-shrink-0"
      [attr.aria-label]="'chat.switcher.close' | translate"
      (click)="close()"
    >
      <i class="ri-close-line"></i>
    </button>
  </div>

  <!-- Results -->
  <div class="chat-switcher__results overflow-auto">
    @if (rows.length === 0) {
      <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-4 px-3 text-center">
        <div class="avatar-sm rounded-circle bg-soft-primary">
          <i class="ri-search-2-line avatar-title text-primary font-18"></i>
        </div>
        <span class="text-muted">{{ 'chat.switcher.empty' | translate }}</span>
        <small class="text-muted">{{ 'chat.switcher.emptyHint' | translate }}</small>
      </div>
    } @else {
      <div class="list-group list-group-flush">

        @if (conversationRows.length > 0) {
          <div class="chat-switcher__section text-muted text-uppercase px-3 pt-2">
            {{ 'chat.switcher.sectionConversations' | translate }}
          </div>
          @for (row of conversationRows; track trackRow($index, row)) {
            <button
              #switcherRow
              type="button"
              class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
              [class.active]="isActive(row)"
              (mouseenter)="setActive(row)"
              (click)="activate(row)"
            >
              <span class="avatar-xs rounded-circle bg-soft-primary flex-shrink-0">
                <i class="avatar-title text-primary font-16" [ngClass]="row.icon"></i>
              </span>
              <span class="flex-grow-1 overflow-hidden text-start">
                <span class="d-block text-truncate fw-semibold">{{ row.label }}</span>
                @if (row.subtitle) {
                  <small class="d-block text-truncate opacity-75">{{ row.subtitle }}</small>
                }
              </span>
              @if (isActive(row)) {
                <i class="ri-corner-down-left-line flex-shrink-0"></i>
              }
            </button>
          }
        }

        @if (loadingPeople) {
          <div class="d-flex align-items-center gap-2 px-3 py-2 text-muted">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <small>{{ 'chat.switcher.loadingPeople' | translate }}</small>
          </div>
        }

        @if (peopleRows.length > 0) {
          <div class="chat-switcher__section text-muted text-uppercase px-3 pt-2">
            {{ 'chat.switcher.sectionPeople' | translate }}
          </div>
          @for (row of peopleRows; track trackRow($index, row)) {
            <button
              #switcherRow
              type="button"
              class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
              [class.active]="isActive(row)"
              (mouseenter)="setActive(row)"
              (click)="activate(row)"
            >
              @if (row.image) {
                <img class="avatar-xs rounded-circle flex-shrink-0" [src]="row.image" [alt]="row.label">
              } @else {
                <span class="avatar-xs rounded-circle bg-soft-primary flex-shrink-0">
                  <span class="avatar-title text-primary">{{ row.initial }}</span>
                </span>
              }
              <span class="flex-grow-1 overflow-hidden text-start">
                <span class="d-block text-truncate fw-semibold">{{ row.label }}</span>
                @if (row.subtitle) {
                  <small class="d-block text-truncate opacity-75">{{ row.subtitle }}</small>
                }
              </span>
              @if (isActive(row)) {
                <i class="ri-corner-down-left-line flex-shrink-0"></i>
              }
            </button>
          }
        }

        @if (actionRow) {
          <div class="chat-switcher__section text-muted text-uppercase px-3 pt-2">
            {{ 'chat.switcher.sectionActions' | translate }}
          </div>
          <button
            #switcherRow
            type="button"
            class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
            [class.active]="isActive(actionRow)"
            (mouseenter)="setActive(actionRow)"
            (click)="activate(actionRow)"
          >
            <span class="avatar-xs rounded-circle bg-soft-primary flex-shrink-0">
              <i class="avatar-title text-primary font-16" [ngClass]="actionRow.icon"></i>
            </span>
            <span class="flex-grow-1 overflow-hidden text-start text-truncate">{{ actionRow.label }}</span>
            @if (isActive(actionRow)) {
              <i class="ri-corner-down-left-line flex-shrink-0"></i>
            }
          </button>
        }

      </div>
    }
  </div>

  <!-- Keyboard hint -->
  <div class="chat-switcher__footer border-top px-3 py-2 d-flex align-items-center justify-content-between">
    <small class="text-muted">{{ 'chat.switcher.hintNavigate' | translate }}</small>
    <small class="text-muted">{{ 'chat.switcher.hintClose' | translate }}</small>
  </div>

</div>
